var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('Fields',_vm._b({},'Fields',{fields: _vm.fields, object: _vm.formData, errors: _vm.formErrors},false)),_vm._v(" "),_c('v-btn',{attrs:{"type":"submit","color":"primary"}},[_vm._v("Wyślij")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a28c8ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plan/PlanCommentForm.vue
// module id = 704
// module chunks = 2